<!-- 通用预览面板组件 - 用于表单和状态的预览 -->
<template>
    <div class="preview-panel">
        <!-- 手机模型区域 -->
        <div class="phone-mockup">
            <iframe
                class="iframe-box"
                :src="iframeSrc"
                frameborder="0"
                width="375"
                height="600"
                scrolling="auto"
                allowfullscreen
            ></iframe>
            <div class="qr-section">
                <!-- 状态图例（仅状态预览时显示） -->
                <div v-if="type === 'status'" class="status-legend">
                    <h3>{{ statusTitle }}</h3>
                    <ul>
                        <li v-for="(item, index) in statusItems" :key="index">
                            <span
                                class="dot"
                                :style="{ backgroundColor: item.color }"
                            ></span>
                            {{ item.name }}
                        </li>
                    </ul>
                </div>
                <!-- 二维码区域 -->
                <VueQr
                    class="qr-code"
                    id="vueQr"
                    :text="iframeSrc"
                ></VueQr>
                <Button class="mt16" @click="handleCopyLink">复制链接</Button>
            </div>
        </div>
    </div>
</template>

<script>
import VueQr from "vue-qr";
export default {
    components: { VueQr },
    name: "PreviewPanel",
    props: {
        // 类型：'form' 或 'status'
        type: {
            type: String,
            default: "form",
            validator: (value) => ["form", "status"].includes(value),
        },
        // iframe 地址（同时用于iframe和二维码）
        iframeSrc: {
            type: String,
            required: true,
        },
        // 状态标题（仅 status 类型使用）
        statusTitle: {
            type: String,
            default: "状态标题",
        },
        // 状态项列表（仅 status 类型使用）
        statusItems: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        handleCopyLink() {
            if (this.iframeSrc) {
                // 复制到剪贴板 - 兼容处理
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    // 使用现代 Clipboard API
                    navigator.clipboard.writeText(this.iframeSrc).then(() => {
                        this.$Message.success("链接已复制");
                    }).catch(err => {
                        console.error('复制失败:', err);
                        this.fallbackCopyTextToClipboard(this.iframeSrc);
                    });
                } else {
                    // 降级方案：使用传统方法
                    this.fallbackCopyTextToClipboard(this.iframeSrc);
                }
            } else {
                this.$Message.warning("暂无可复制的链接");
            }
        },
        // 降级复制方案（兼容旧浏览器）
        fallbackCopyTextToClipboard(text) {
            const textArea = document.createElement("textarea");
            textArea.value = text;
            
            // 设置样式使其不可见
            textArea.style.position = "fixed";
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.width = "2em";
            textArea.style.height = "2em";
            textArea.style.padding = "0";
            textArea.style.border = "none";
            textArea.style.outline = "none";
            textArea.style.boxShadow = "none";
            textArea.style.background = "transparent";
            
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            
            try {
                const successful = document.execCommand("copy");
                if (successful) {
                    this.$Message.success("链接已复制");
                } else {
                    this.$Message.error("复制失败，请手动复制");
                }
            } catch (err) {
                console.error('复制失败:', err);
                this.$Message.error("复制失败，请手动复制");
            }
            
            document.body.removeChild(textArea);
        },
    },
};
</script>

<style scoped>
.preview-panel {
    display: flex;
    justify-content: center;
}

.phone-mockup {
    display: flex;
    gap: 40px;
}

.iframe-box {
    border: 1px solid #e8eaec;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.qr-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 20px;
}

.status-legend {
    margin-bottom: 20px;
}

.status-legend h3 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
    color: #333;
}

.status-legend ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.status-legend li {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
}

.dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 8px;
}

.qr-code {
    width: 150px;
    height: 150px;
    background: #f5f5f5;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 12px;
}

.mt16 {
    margin-top: 16px;
}
</style>
